import { render } from "./MultiSettingTab.vue?vue&type=template&id=50464996&scoped=true&ts=true"
import script from "./MultiSettingTab.vue?vue&type=script&lang=ts"
export * from "./MultiSettingTab.vue?vue&type=script&lang=ts"

import "./MultiSettingTab.vue?vue&type=style&index=0&id=50464996&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50464996"]])

export default __exports__